import React, { FunctionComponent } from "react";
import ErrorDialog from "designSystem/components/dialog/ErrorDialog";
import { MessageDialogProps } from "designSystem/components/dialog/MessageDialog";

interface InvalidAttachmentDialogProps extends MessageDialogProps {
	/** list of invalid filenames */
	filenames: string[];
}

export const InvalidAttachmentDialog: FunctionComponent<InvalidAttachmentDialogProps> = (props) => {
	const { filenames, ...otherProps } = props;
	return (
		<ErrorDialog
			messageRes="ErrorInvalidFiles"
			messageResParams={[filenames.join(", ")]}
			titleRes="CommentAttach"
			{...otherProps}
		/>
	);
};

export default InvalidAttachmentDialog;